import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDSZI4Mo4WCXa1_EpNP8dHSKFJxqQs0mpY",
  authDomain: "travelapp-1e311.firebaseapp.com",
  projectId: "travelapp-1e311",
  storageBucket: "travelapp-1e311.firebasestorage.app",
  messagingSenderId: "824423613925",
  appId: "1:824423613925:web:e367ba5d11b0dcafa65b0c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;